import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

// Group invites from the native app are universal links: iOS opens the app when
// it is installed, otherwise the website shows App Store / Telegram buttons.
// The code is <referral>-<uniqueGroupKey>, the same value Telegram gets as startapp.
const GROUP_INVITE_URL = 'https://starindustry.io/invite/';
const PENDING_KEY = 'pendingGroupInvite';
const EVENT = 'group-invite';
// https://starindustry.io[/ru]/invite/<referral>-<groupKey>
const INVITE_URL_RE =
  /^https:\/\/starindustry\.io(?:\/[a-z]{2})?\/invite\/([^/?#]+)/;

const groupInviteLink = (referral: string, groupKey: string): string =>
  `${GROUP_INVITE_URL}${referral}-${groupKey}`;

const parseGroupKey = (url: string): string | null => {
  const match = INVITE_URL_RE.exec(url);

  // Same split as parseStartParam on the backend
  return match?.[1].split('-')[1] || null;
};

const savePending = (url: string): void => {
  const groupKey = parseGroupKey(url);

  if (!groupKey) return;

  try {
    localStorage.setItem(PENDING_KEY, groupKey);
  } catch {
    return;
  }
  window.dispatchEvent(new Event(EVENT));
};

// Kept until the user is logged in, see NativeGroupInvite
const takePendingGroupInvite = (): string | null => {
  try {
    const groupKey = localStorage.getItem(PENDING_KEY);
    localStorage.removeItem(PENDING_KEY);

    return groupKey;
  } catch {
    return null;
  }
};

const onGroupInvite = (listener: () => void): (() => void) => {
  window.addEventListener(EVENT, listener);

  return (): void => window.removeEventListener(EVENT, listener);
};

const installGroupInviteLinks = (): void => {
  if (!Capacitor.isNativePlatform()) return;

  void App.addListener('appUrlOpen', ({ url }) => savePending(url));
  void App.getLaunchUrl().then((launch) => launch && savePending(launch.url));
};

export {
  groupInviteLink,
  installGroupInviteLinks,
  onGroupInvite,
  takePendingGroupInvite,
};
